import { render, staticRenderFns } from "./ReportsOrders.vue?vue&type=template&id=370a5bad&scoped=true&"
import script from "./ReportsOrders.vue?vue&type=script&lang=js&"
export * from "./ReportsOrders.vue?vue&type=script&lang=js&"
import style0 from "./ReportsOrders.vue?vue&type=style&index=0&id=370a5bad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a5bad",
  null
  
)

export default component.exports